import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaCopy, FaEye } from "react-icons/fa";
import { CgClose } from "react-icons/cg";
import axiosInstance from "../utils/axiosInstance";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner";

const EditSecret = () => {
    const{id}=useParams()
    const [loading,setLoading]=useState(false)
  const [formValues, setFormValues] = useState({
    key: "",
    newValue: "",
   
    description: "",
  });
  const [secretValue, setSecretValue] = useState("");
  const [value, setValue] = useState("");


  

  const [encryptModal, toggleEncryptModal] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true)
      const res = await axiosInstance.post(`/config/updateSecret/`, formValues);
      if (res) {
        toast.success("Secret updated successfully");
        setLoading(false)

        // Add redirect logic here if needed
      }
    } catch (error) {
      setLoading(false)
      toast.error(error?.response?.data?.message || "An error occurred");
    }
  };

  const copyToClipboard = (variable) => {
    navigator.clipboard.writeText(variable).then(
      () => {
        toast.success(`Copied: ${variable}`);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

//   const encrypt = async (value) => {
//     try {
//       const res = await axiosInstance.get(`/admin/secret/view-secret-value/${value}`);
//       toggleEncryptModal(res.data.data.value);
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "An error occurred");
//     }
//   };

  const closeModal = () => {
    toggleEncryptModal("");
  };

  useEffect(() => {
    if (id) {
      const fetchSecret = async () => {
        try {
          setLoading(true)
          const res = await axiosInstance.get(`/config/getSecretValue/${id}`);
          if (res.data) {
            setFormValues({
              key: id,
              value: "",
            
              
            });
          }
          setSecretValue(res.data.data.secretValue || "");
          setValue(res.data.data.value || "");
          setLoading(false)
        } catch (error) {
          setLoading(false)

          toast.error(error?.response?.data?.message || "An error occurred");
        }
      };

      fetchSecret();
    }
  }, [id]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Edit Secret</h1>
{loading&&<LoadingSpinner />}
      {/* Encrypt Modal */}
      {encryptModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Encrypt Values</h2>
              <CgClose
                size={20}
                className="cursor-pointer"
                onClick={closeModal}
              />
            </div>
            <div className="p-4 bg-gray-100 rounded shadow-sm flex items-center">
              <span className="font-bold mr-2">{formValues.key}:</span>
              <span className="text-primary ml-2">{encryptModal}</span>
              <FaCopy
                color="#20bb83"
                size={20}
                className="cursor-pointer ml-auto"
                onClick={() => copyToClipboard(encryptModal)}
              />
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-md shadow-md">
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Key</label>
          <input
            type="text"
            name="key"
            value={formValues.key}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Key"
          />
        </div>

        <div className="mb-4">
  <label className="block text-sm font-medium mb-1">Secret Value</label>
  <div className="flex items-center bg-gray-100 border px-3 py-2 rounded">
    <span className="truncate mr-2">{value}</span>
    <FaCopy
      size={18}
      className="ml-auto text-blue-500 cursor-pointer"
      onClick={() => copyToClipboard(secretValue)}
    />
  </div>
</div>
<div className="mb-4">
  <label className="block text-sm font-medium mb-1">New Value</label>
  <input
    type="text"
    name="value"
    value={formValues.value}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded px-3 py-2"
    placeholder="Enter Value"
  />
</div>

        

        {/* <div className="mb-4">
          <label className="block text-sm font-medium mb-1">New Value</label>
          <input
            type="text"
            name="newValue"
            value={formValues.newValue}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter New Value"
          />
        </div> */}
{/* 
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Description</label>
          <textarea
            name="description"
            value={formValues.description}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Description"
            rows="5"
          />
        </div> */}

        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default EditSecret;
